(function($){
    Forms.Validators = {
        map: {
            'class-only': 'ClassOnlyValidator',
            'real-time-all': 'RealTimeAllValidator'
        },
        parent: {
            addError: window.Nette.addError,
            validateControl: window.Nette.validateControl,
            validateForm: window.Nette.validateForm
        },
        ready: function () {

            var self = this;

            // init default validator
            this.defaultValidator = this.createDefaultValidator();

            // override
            window.Nette.addError = function(el, message){
                var validator = self.getValidator($(el).closest('form'));
                // call validator error handler
                validator.onError.apply(this, arguments);
            };
            window.Nette.validateControl = function(el, rules, onlyCheck){
                var validator = self.getValidator($(el).closest('form'));
                if (!onlyCheck){
                    // call validator success handler
                    validator.onSuccess.call(this, el);
                }
                return self.parent.validateControl.apply(this, arguments);
            };

            // bind to more form events
            this.bind();

        },
        bind: function () {

            var self = this;

            $('form').each(function(){
                self.bindForm(this);
            });

        },
        bindForm: function (form) {

            var validator = this.getValidator($(form));

            // subscribe to input events
            var inputEvents = [];
            if (validator.on.change){
                inputEvents.push('change');
            }
            if (validator.on.keydown){
                inputEvents.push('keydown');
            }
            if (validator.on.focus){
                inputEvents.push('focus');
            }
            if (validator.on.blur){
                inputEvents.push('blur');
            }
            if (inputEvents.length){
                $(form).on(inputEvents.join(' '), 'input, select, textarea', function (e) {
                    Nette.validateForm(form);
                });
            }

            // ready event
            if (validator.on.ready){
                Nette.validateForm(form);
            }

        },
        createDefaultValidator: function(){

            return {
                on: {
                    submit: true, /* TODO support false here */
                    ready: false,
                    change: false,
                    keydown: false,
                },
                onError: this.parent.addError,
                onSuccess: function(){  }
            };

        },
        getValidator: function($form){

            var id = $form.data('validator');

            return this.map[id] ? this[this.map[id]] : this.defaultValidator;

        }
    };
})(jQuery);